export default __webpack_public_path__ + "6018f97203d39e0dfc6d481e1424d944.ttf";